import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileArchive, faFileCode, faFilePdf, faTerminal } from '@fortawesome/free-solid-svg-icons';
import { CONNECTION_TYPES } from '@shared/constants/connectionTypes';
import { QUOTATION_INSURANCE_CARRIER_STATE } from '@/shared/constants/quotationInsuranceCarrierStates';

export const getMenuItems = ({ record, userProfileId, isSupportUser, actions }) => {
  const isProcessing = record.state === QUOTATION_INSURANCE_CARRIER_STATE.PROCESSING;
  const hasPdfUrl = Boolean(record.complete_public_url);
  const canViewPdf = hasPdfUrl && !isProcessing;

  return [
    {
      key: 'viewPdf',
      label: 'Ver PDF',
      icon: <FontAwesomeIcon icon={faFilePdf} />,
      onClick: actions.viewPdf.handler,
      loading: actions.viewPdf.loading,
      disabled: !canViewPdf,
      disabledTooltip: isProcessing
        ? 'El PDF estará disponible cuando finalice el procesamiento.'
        : 'No hay un PDF disponible.',
    },
    {
      key: 'downloadRequestsResponses',
      label: 'Descargar requests-responses',
      icon: <FontAwesomeIcon icon={faFileCode} />,
      onClick: actions.downloadRequestsResponses.handler,
      loading: actions.downloadRequestsResponses.loading,
      visible: userProfileId === 1,  // Gerente
      disabled: !record.has_log,
      disabledTooltip: 'No hay un requests-responses disponible.',
    },
    {
      key: 'downloadRpaTrace',
      label: 'Descargar trace RPA',
      icon: <FontAwesomeIcon icon={faFileArchive} />,
      onClick: actions.downloadRpaTrace.handler,
      loading: actions.downloadRpaTrace.loading,
      tooltip: 'Disponible solo para usuarios de soporte',
      visible: isSupportUser && record.source_type === CONNECTION_TYPES.RPA,
      disabled: !record.has_log,  // has_log indica si hay un QuotationLog asociado (requisito previo para descargar el trace)
      disabledTooltip: 'No hay un trace RPA disponible.',
    },
    {
      key: 'viewExecutionDetails',
      label: 'Ver detalles de ejecución',
      icon: <FontAwesomeIcon icon={faTerminal} />,
      onClick: actions.viewExecutionDetails.handler,
      loading: actions.viewExecutionDetails.loading,
      tooltip: 'Disponible solo para usuarios de soporte',
      visible: isSupportUser,
    },
  ];
};
